<sc-list-set (onClick)="handleOnClick($event)" [rowData]="rowData" [title]="title" [runAnimation]="runAnimation">
    <ng-template let-row="row" let-index="index">
        <div id="{{row.id}}">
            <div class="list-row--icons">
                <img [src]="row.icon" [alt]="row.text">
            </div>
            <span class="list-row--title">{{row.text}}</span>
        </div>
    </ng-template>
</sc-list-set>
